import { AppProvider } from './provider';
import { AppRouter } from './router';
import { Toaster } from '../components/ui/sonner';

export const App = () => {
  return (
    <AppProvider>
      <AppRouter />
      <Toaster position="top-center" className="pointer-events-auto mt-8!" />
    </AppProvider>
  );
};
